import { QuantifyState } from '@modules/quantify/store/types';
import { getHasMetadataFilterForEqlField } from '@modules/quantify/utils';
import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import {
  OperationType,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

interface CombineWhereClauseWithMetadataFilterIfRequiredParams {
  whereClause: WhereClause;
  groupBy: QuantifyState['query']['groupByField'];
}

export const combineWhereClauseWithMetadataFilterIfRequired = ({
  whereClause,
  groupBy,
}: CombineWhereClauseWithMetadataFilterIfRequiredParams) => {
  const metadataFilter = getHasMetadataFilterForEqlField(groupBy);

  if (!metadataFilter) {
    return whereClause;
  }

  return combineWhereClauses(whereClause, metadataFilter, OperationType.AND);
};
